import { Table } from 'dexie';
import { Survey } from '../models/survey.model';
import { Injectable } from '@angular/core';
import { DexieDatabaseBase } from './dexie-hardening';

export type SurveySnapshotReason = 'publish' | 'load-remote' | 'delete-sheet' | 'before-restore' | 'before-hubspot-refresh' | 'count-drop' | 'inactive-cleanup';

export interface SurveySnapshot {
  id?: number;
  surveyId: string;
  createdAt: number;
  reason: SurveySnapshotReason;
  sheetCount: number;
  locationCount: number;
  survey: Survey;
}

@Injectable({ providedIn: 'root' })
export class SurveyDatabase extends DexieDatabaseBase {
  surveys: Table<Survey, string>;
  surveySnapshots: Table<SurveySnapshot, number>;

  constructor() {
    super('NexusSurveyDB');

    this.version(1).stores({
      surveys: 'id, updatedAt',
    });

    this.version(2).stores({
      surveys: 'id, updatedAt',
      surveySnapshots: '++id, surveyId, createdAt',
    });
  }
}
